import { render, staticRenderFns } from "./AddNewRelicModal.vue?vue&type=template&id=05e06914&"
import script from "./AddNewRelicModal.vue?vue&type=script&lang=js&"
export * from "./AddNewRelicModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports